import * as React from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  DialogTitle,
} from "@mui/material";

export default function TermAndConditionPopup(props) {
  const { open, handleClose } = props;

  return (
    <>
      <span
        onClick={(e) => {
          e.preventDefault();
          handleClose(true);
        }}
        style={{
          cursor: "pointer",
          color: "#4d6fa5",
          textDecoration: "underline",
        }}
      >
        Terms & Conditions
      </span>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={"xxl"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
          {" "}
          <Typography color="primary" variant="h6">
            DOCK APPOINTMENT SYSTEM TERMS AND CONDITIONS
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container sx={{ px: 3 }}>
            <Grid
              className="term-condition"
              item
              xs={12}
              md={12}
              sx={{ pl: 3 }}
            >
              <>
                <p>
                  <strong>DOCK APPOINTMENT SYSTEM TERMS AND CONDITIONS</strong>
                </p>
                <p>
                  <br />
                </p>
                <p>Welcome to Dock Appointment System!</p>
                <p>
                  <br />
                </p>
                <p style={{ textAlign: "justify" }}>
                  The terms and conditions as set out herein (&ldquo;
                  <strong>Terms</strong>&rdquo;) constitute an agreement between
                  Reliance Retail Limited (&ldquo;<strong>we</strong>&rdquo;,
                  &ldquo;<strong>us</strong>&rdquo; or &ldquo;
                  <strong>our</strong>&rdquo;), which operates
                  the&nbsp;&nbsp;Dock Appointment System (<em>defined below</em>
                  ) and a natural or legal person who accesses and/or uses Dock
                  Appointment System in any manner (&ldquo;<strong>you</strong>
                  &rdquo; or &ldquo;<strong>your</strong>&rdquo;) or uses any
                  current or future service or functionality or offer made
                  available on Dock Appointment System (&ldquo;
                  <strong>Service(s)</strong>&rdquo;), as updated from time to
                  time.
                </p>
                <p>
                  <br />
                </p>
                <p style={{ textAlign: "justify" }}>
                  By using the Dock Appointment System, you expressly agree to
                  be bound by the Terms. If you do not agree with any of the
                  Terms, please do not use the Dock Appointment System. If you
                  have any questions about the terms, please contact at [
                  <em>insert email</em>]. Please note that your access to the
                  Services, other platforms or utilisation of Products (
                  <em>defined below</em>), offers or promotions in relation to
                  the Products as may be provided by us or our affiliates, may
                  be governed by other terms and conditions, policies or
                  guidelines (&ldquo;<strong>Additional Terms</strong>&rdquo;)
                  along with these Terms. If these Terms are inconsistent with
                  any Additional Terms, the Additional Terms will control to the
                  extent of such inconsistency with respect to the applicable
                  Service or utilisation of the Product. These Terms govern your
                  use of the &lt;&lt;&gt;&gt; and transaction or dealings
                  thereon.
                </p>
                <p>
                  <br />
                </p>
                <p style={{ textAlign: "justify" }}>
                  For the purposes of these Terms: (a) &ldquo;Dock Appointment
                  System&rdquo; means the &lt;&lt;&gt;&gt;, which include its
                  corresponding mobile application/wallet/
                  website/tablet/desktop or any other digital mode and/or
                  operating system as provided by us, on which you may avail the
                  Services and includes applications controlled and managed by
                  us which interact with one or more such mobile applications/
                  wallets/ websites/ tablets and digital modes as provided by
                  us; (b) &ldquo;<strong>Products</strong>&rdquo; shall mean
                  &lt;&lt;&gt;&gt; and other products offered for sale to you on
                  the Dock Appointment System; and (c) We and you are
                  hereinafter individually referred to as &ldquo;
                  <strong>Party</strong>&rdquo; and collectively as &ldquo;
                  <strong>Parties</strong>&rdquo;.
                </p>
                <p>
                  <br />
                </p>
                <p>
                  These Terms are divided into 2 (two) parts. Please carefully
                  read all the parts to understand the conditions applicable in
                  case of usage of the Dock Appointment System and for purchase
                  of Products thereof.
                </p>
                <p>
                  <br />
                </p>
                <p>
                  <strong>
                    PART A &ndash; TERMS AND CONDITIONS FOR USAGE OF Dock
                    Appointment System
                  </strong>
                </p>
                <p>
                  <br />
                </p>
                <ol>
                  <li>
                    <strong>GENERAL</strong>

                    <ol>
                      <li>
                        The terms and conditions for usage of the Dock
                        Appointment System as set out herein (&ldquo;
                        <strong>Terms of Use</strong>&rdquo;) specifically
                        govern your access and use of the Dock Appointment
                        System, which provides a forum for you to{" "}
                        <em>inter alia&nbsp;</em>
                        enable you to discover, select and buy Products listed
                        on &lt;&lt;&gt;&gt; at the indicated price at any time,
                        from the locations serviceable by us.
                      </li>
                      <li>
                        Please note that we may from time to time change the
                        Terms of Use that govern your use of the
                        &lt;&lt;&gt;&gt;. Every time you wish to use our Dock
                        Appointment System, please check these Terms of Use to
                        ensure you understand the terms and conditions that
                        apply at that time. Further, please note that we reserve
                        the right to either change the format and the content of
                        the Dock Appointment System or suspend the operation of
                        the Dock Appointment System for support or maintenance
                        work, in order to update the content or for any other
                        reason, at any time.
                      </li>
                      <li>
                        Any accessing, br/owsing, or otherwise using the Dock
                        Appointment System indicates your agreement to these
                        Terms of Use, the privacy policy of Dock Appointment
                        System (available here: [
                        <em>
                          insert the hyperlink of the &lt;&lt;&gt;&gt; privacy
                          policy
                        </em>
                        ]) and any other policies or guidelines that may be
                        applicable on the &lt;&lt;&gt;&gt; at the time of your
                        access and usage of the &lt;&lt;&gt;&gt; and which may
                        be updated from time to time (collectively, the &ldquo;
                        <strong>Agreement</strong>&rdquo;).&nbsp;
                      </li>
                      <li>
                        This document is an electronic record in terms of the
                        Information Technology Act, 2000 and rules made
                        thereunder as may be applicable, and the amended
                        provisions pertaining to electronic records in various
                        statutes as amended by the Information Technology Act,
                        2000. This electronic record is generated by a computer
                        system and does not require any physical or digital
                        signatures.
                      </li>
                      <li>
                        We authorise you to view and access the Dock Appointment
                        System solely for identifying Products, carrying out
                        purchases of Products and processing returns and
                        refunds, in accordance with Return and Refund Policy
                        (available here: [
                        <em>
                          insert the hyperlink of the &lt;&lt;&gt;&gt; return
                          and refund policy
                        </em>
                        ]), therefore, grant you a limited, revocable permission
                        to access and use the Services.&nbsp;
                      </li>
                      <li>
                        By accepting this Agreement, you affirm that you are 18
                        (Eighteen) years of age or above and are fully competent
                        to enter into this Agreement, and to abide by and comply
                        with this Agreement. If a user is below 18 (Eighteen)
                        years of age, it is assumed that he/she is
                        using/br/owsing the Dock Appointment System under the
                        supervision of his/her parent or legal guardian and that
                        such user&rsquo;s parent or legal guardian has read and
                        agrees to the terms of this Agreement, including terms
                        of purchase of Products on behalf of the minor user. In
                        the event we are made aware that a user is under the age
                        of 18 and is using/br/owsing the Dock Appointment System
                        without the supervision of his/her parent or legal
                        guardian, we reserve the right to deactivate such
                        user&rsquo;s account without further notice. Further, if
                        you are using the Services on behalf of a company or
                        organisation, you represent that you have authority to
                        act on behalf of that entity, and that such entity
                        accepts this Agreement.
                      </li>
                    </ol>
                  </li>
                  <li>
                    <strong>REGISTRATION OF YOUR ACCOUNT</strong>

                    <ol>
                      <li>
                        In order to purchase Products on the Dock Appointment
                        System and/or avail the Services, you will have to
                        register on the Dock Appointment System. Registration is
                        a one-time process. You will be eligible to further
                        access and avail the Services only upon receipt of a
                        confirmation e-mail from us after filling in the
                        necessary forms and after providing the necessary
                        details as may be required by us at the time of your
                        registration.&nbsp;
                      </li>
                      <li>
                        You are solely authorized to operate the account created
                        by you. Consequently, it is your responsibility to
                        maintain the confidentiality of the log in credentials
                        of your account on the Dock Appointment System and for
                        restricting access to your computer/mobile/other similar
                        devices to prevent unauthorized access to your account.
                        You shall remain solely liable for all the actions
                        undertaken through your account.
                      </li>
                      <li>
                        You will: (a) immediately inform us of any unauthorized
                        use of the account or any other security br/each; and
                        (b) ensure that you log out of your account at the end
                        of each session. We, our employees, agents, directors
                        and officers will not be liable for any loss or direct
                        or indirect damage arising from your failure to comply
                        with these Terms of Use. You may be held liable for any
                        losses incurred to us or any other user due to
                        unauthorized use of their account by you. We reserve the
                        right to refuse access to the Dock Appointment System,
                        terminate accounts, remove or edit content at any time
                        without notice to you.
                      </li>
                    </ol>
                  </li>
                  <li>
                    <strong>COMMUNICATION AND UNSUBSCRIPTION</strong>
                    <ol>
                      <li>
                        By accepting the Terms of Use, you also accept to
                        receive news, updates, offers/ campaign related SMS, to
                        the mobile phone number provided by you. By accessing
                        and using the Dock Appointment System and/ or verifying
                        your contact number with us, you explicitly consent to
                        receive such communications (through call, SMS, email or
                        other digital and electronic means) from us and/or our
                        authorized representatives regarding any new services or
                        offerings, even if your contact number is registered
                        under the DND/NCPR list under the Telecom Commercial
                        Communications Customer Preference Regulations, 2018.
                      </li>
                      <li>
                        You can unsubscribe/ opt-out from receiving marketing/
                        promotional communications, newsletters and other
                        notifications from us at any time by following the
                        instructions set out in such communications.
                      </li>
                    </ol>
                  </li>
                  <li>
                    <strong>
                      DISCLAIMER OF WARRANTIES, INACCURACIES OR ERRORS
                    </strong>
                    <ol>
                      <li>
                        We will try to ensure that all information and
                        recommendations, whether in relation to the Products,
                        Services, offerings or otherwise (hereinafter &ldquo;
                        <strong>Information</strong>&rdquo;) provided as part of
                        this Dock Appointment System is correct at the time of
                        inclusion on the Dock Appointment System. We do not
                        guarantee the accuracy of the Information. We make no
                        representations or warranties as to the completeness or
                        accuracy of Information.
                      </li>
                      <li>
                        You agree that Information is being supplied to you on
                        the condition that you will make your own determination
                        as to the suitability of such information for your
                        purpose prior to use or in connection with the making of
                        any decision. No Information on the Dock Appointment
                        System shall constitute an invitation to invest in us or
                        any affiliates. Any use of this Dock Appointment System
                        or the Information is at your own risk. Neither we, our
                        affiliates, nor their officers, employees or agents
                        shall be liable for any loss, damage or expense arising
                        out of any access to, use of, or reliance upon, this
                        website, the Information, or any third-party website
                        linked to this Dock Appointment System. We are not
                        responsible for the content of any third-party sites and
                        do not make any representations regarding the content or
                        accuracy of material on such sites. If you decide to
                        access links of any third-party platforms, you are doing
                        so entirely at your own risk and expense.
                      </li>
                      <li>
                        As means to assist the users in identifying the Products
                        of their choice, we provide visual representations on
                        the Dock Appointment System including graphics,
                        illustrations, photographs, images, videos, charts,
                        screenshots, infographics and other visual aids. While
                        reasonable efforts are made to provide accurate visual
                        representation, we disclaim any guarantee or warranty of
                        exactness of such visual representation or description
                        of the Product, with the actual Product ultimately
                        delivered to users. The appearance of the Product when
                        delivered may vary for various reasons.
                      </li>
                      <li>
                        Nothing contained herein is to be construed as a
                        recommendation to use any Product, process, equipment or
                        formulation, in conflict with any patent, or otherwise
                        and we make no representation or warranty, express or
                        implied that, the use thereof will not infringe any
                        patent, or otherwise.
                      </li>
                      <li>
                        We do not covenant or provide any representations and
                        warranties:
                        <ol>
                          <li>
                            in respect of quality, suitability, accuracy,
                            reliability, performance, safety, merchantability,
                            fitness for a particular purpose/consumption or the
                            content (including Product or pricing information
                            and/or specifications) on Dock Appointment System;
                          </li>
                          <li>
                            that the Services will be made available at all
                            times; and
                          </li>
                          <li>
                            that the operation of Dock Appointment System,
                            including the functions contained in any content,
                            information and materials on Dock Appointment System
                            or any third-party sites or services linked to Dock
                            Appointment System will be uninterrupted, or that
                            the defects will be rectified, or that Dock
                            Appointment System or the servers that make such
                            content, information and materials available are
                            free of viruses or other harmful components.
                          </li>
                        </ol>
                      </li>
                      <li>
                        THIS Dock Appointment System AND THE SERVICES ARE
                        PROVIDED TO YOU ON AN &ldquo;AS IS&rdquo; AND
                        &ldquo;WHERE-IS&rdquo; BASIS, WITHOUT ANY
                        REPRESENTATIONS OR WARRANTIES. WE, FOR OURSELF AND ANY
                        THIRD-PARTY PROVIDING MATERIALS, SERVICES, OR CONTENT TO
                        THIS WEBSITE, MAKE NO REPRESENTATIONS OR WARRANTIES,
                        EITHER EXPRESS, IMPLIED, STATUTORY OR OTHERWISE OF
                        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR
                        NONINFRINGEMENT OF THIRD-PARTY RIGHTS, WITH RESPECT TO
                        THE &lt;&lt;&gt;&gt;, THE INFORMATION OR ANY PRODUCTS OR
                        SERVICES TO WHICH THE INFORMATION REFERS. WE WILL NOT BE
                        LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DAMAGES OF ANY
                        KIND, INCLUDING BUT NOT LIMITED TO, DIRECT, INDIRECT,
                        INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, ARISING
                        FROM OR CONNECTED WITH THE SITE, INCLUDING BUT NOT
                        LIMITED TO, YOUR USE OF THIS SITE OR YOUR INABILITY TO
                        USE THE SITE, EVEN IF WE HAVE PREVIOUSLY BEEN ADVISED OF
                        THE POSSIBILITY OF SUCH DAMAGES.
                      </li>
                      <li>
                        <strong>Disclaimer</strong> <strong>-</strong>To the
                        extent permitted by applicable law, We, our officers,
                        agents, employees and directors, disclaim any liability
                        against any loss, damage, expenses, liabilities, claim,
                        injury caused due to the failure of performance,
                        omission, defect of products, or deletion, interruption,
                        error, delay, virus, communication, unauthorised access,
                        theft, destruction, alteration or use of records on the
                        Dock Appointment System.
                      </li>
                    </ol>
                  </li>
                </ol>
                <li>
                  <strong>AVAILIBILITY AND ACCESIBILITY OF&nbsp;</strong>Dock
                  Appointment System
                  <ol>
                    <li>
                      We control and operate this Dock Appointment System from
                      India and makes no representation that the materials and
                      the content available on the Dock Appointment System are
                      appropriate to be used or will be available for use in
                      other locations outside India. If you use this Dock
                      Appointment System from outside India, you are entirely
                      responsible for compliance with all applicable local laws.
                      These Terms of Use do not constitute, nor may these Terms
                      of Use be used for or in connection with any promotional
                      activities or solicitation by anyone in any jurisdiction
                      in which such promotional activities or solicitation are
                      not authorized or to any person to whom it is unlawful to
                      promote or solicit.
                    </li>
                    <li>
                      We have several websites offering Products, Services,
                      content and various other functionalities&nbsp;&nbsp;to
                      specific regions worldwide. The Services offered in one
                      region may differ from those in other regions due to
                      availability, local or regional laws, shipment and other
                      considerations. We do not make any warranty or
                      representation that a user in one region may obtain the
                      Services from our site in another region and we may cancel
                      a user&apos;s order or redirect a user to the site for
                      that user&rsquo;s region if a user attempts to order
                      Services offered on a site in another region.
                    </li>
                    <li>
                      Information that we publish on the world wide web may
                      contain references or cross references to our Products,
                      programs and Services that are not announced or available
                      in your country. Such references do not imply that we
                      intend to announce such Products, programs or Services in
                      your country. Consult our local business contact for
                      information regarding the Products, programs and Services
                      that may be available to you.
                    </li>
                    <li>
                      We constantly monitor the user&rsquo;s account in order to
                      avoid fraudulent accounts and transactions. Users with
                      more than one account or availing referral vouchers
                      fraudulently shall be liable for legal actions under law
                      and we reserve the right to recover the cost of goods,
                      collection charges and lawyer fees from persons using the
                      Dock Appointment System fraudulently. We reserve the right
                      to initiate legal proceedings against such persons for
                      fraudulent use of the Dock Appointment System and any
                      other unlawful acts or omissions in br/each of these terms
                      and conditions. In the event of detection of any
                      fraudulent or declined transaction, prior to initiation of
                      legal actions, we reserve the right to immediately delete
                      such account and dishonour all past and pending orders
                      without any liability. For the purpose of this clause, we
                      shall owe no liability for any refunds.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>
                    THIRD PARTY INTERACTION AND LINKS TO THIRD PARTY SITES
                  </strong>
                  <ol>
                    <li>
                      In your use of Dock Appointment System you may enter into
                      correspondence with, purchase goods and/or services from,
                      or participate in promotions of advertisers or members or
                      sponsors of Dock Appointment System or access any other
                      third-party website linked to the Dock Appointment System
                      Unless otherwise stated, any such correspondence,
                      advertisement, purchase or promotion, including the
                      delivery of and the payment for goods and/or services, and
                      any other term, condition, warranty or representation
                      associated with such correspondence, purchase or
                      promotion, is solely between you and the applicable third
                      party. You agree that we have no liability, obligation or
                      responsibility for any such correspondence, purchase or
                      promotion, access or usage of any third-party website and
                      the contract under such instances remains between you and
                      any such third party.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>COPYRIGHTS IN RELIANCE CONTENT</strong>
                  <ol>
                    <li>
                      The Dock Appointment System contains material, including
                      text, graphics and sound, which is protected by copyright
                      and/or other intellectual property rights (&ldquo;
                      <strong>Reliance Content</strong>&rdquo;). All copyright
                      and other intellectual property rights in the Reliance
                      Content are either owned by us or have been licensed to us
                      by the owner(s) of those rights so that it can use the
                      Reliance Content as part of Dock Appointment System We
                      retain copyright on all Information, including text,
                      graphics and sound and all trademarks displayed on the
                      Dock Appointment System are either owned by or licensed to
                      us.
                    </li>
                    <li>
                      You may use and display the Reliance Content on your
                      personal computer only for your personal use subject to
                      the grant of a limited, revocable, personal, non-exclusive
                      and non-transferable license to you by us when you
                      register on the Dock Appointment System only for
                      identifying Products, carrying out purchases of Products
                      and processing returns and refunds in accordance with our
                      Return and Refund Policy and for using and printing copies
                      of the information on the Dock Appointment System for your
                      personal use and store the files on your computer for
                      personal use only and not for business purposes.
                    </li>
                    <li>
                      You may not: (a) copy (whether by printing off onto paper,
                      storing on disk, downloading or in any other way),
                      distribute (including distributing copies), download,
                      display, perform, reproduce, distribute, modify, edit,
                      alter, enhance, br/oadcast or tamper within any way or
                      otherwise use any Reliance Content contained in the Dock
                      Appointment System These restrictions apply in relation to
                      all or part of the Reliance Content available on the Dock
                      Appointment System (b) copy and distribute the Information
                      on any other server, or modify or re-use text or graphics
                      on this system or another system; (c) reproduce any part
                      of the Dock Appointment System or sell or distribute the
                      same for commercial gain nor shall it be modified or
                      incorporated in any other work, publication or web site,
                      whether in hard copy or electronic format, including
                      postings to any other web site; (d) remove any copyright,
                      trademark or other intellectual property notices contained
                      in the original material from any material copied or
                      printed off from Dock Appointment System or (e) link any
                      other material to the Dock Appointment System without our
                      express written consent.
                    </li>
                    <li>
                      The license granted to you does not include a license for:
                      (a) resale of Products or commercial use of the Dock
                      Appointment System or Reliance Content, (b) any collection
                      and use of product listings, description, or prices, (c)
                      any use of Dock Appointment System the Services and/or of
                      Reliance Content other than as contemplated in these Terms
                      of Use, (d) any downloading or copying of login
                      credentials of user, (e) any use of data mining, robots,
                      or similar data gathering and extraction tools to extract
                      (whether once or many times) any parts of Dock Appointment
                      System and (f) creating and/ or publishing your own
                      database that features parts of the Dock Appointment
                      System&nbsp;
                    </li>
                    <li>
                      If you believe that your intellectual property rights have
                      been used in a way that raises concerns of infringement,
                      please write to us at [&lt;&gt;email ID&gt;&gt;] and let
                      us know of your concerns.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>TRADEMARKS</strong>
                  <ol>
                    <li>
                      All the trade names associated with us and all Products
                      and logos denoted with TM are trademarks or registered
                      trademarks of us or our affiliates. Our trademarks may not
                      be used in connection with any product or service that is
                      not our product or service.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>LICENSE AND USE OF YOUR CONTENT</strong>
                  <ol>
                    <li>
                      You grant to us a royalty-free, perpetual, irrevocable,
                      non-exclusive right and license to adopt, publish,
                      reproduce, disseminate, transmit, distribute, copy, use,
                      create derivative works from, display worldwide, or act on
                      any material posted by you on the Dock Appointment System
                      without additional approval or consideration in any form,
                      media, or technology now known or later developed, for the
                      full term of any rights that may exist in such content,
                      and you waive any claim over all feedback, comments, ideas
                      or suggestions or any other content provided through or on
                      the Dock Appointment System. You agree to perform all
                      further acts necessary to perfect any of the above rights
                      granted by you to us, including the execution of deeds and
                      documents, at its request.
                    </li>
                    <li>
                      You agree that we do not routinely monitor your postings
                      on Dock Appointment System but reserves the right to do
                      so. However, if we become aware of inappropriate use of
                      the Dock Appointment System or any of its Services, we
                      will respond in any way that, in its sole discretion, we
                      deem appropriate. You acknowledge that we will have the
                      right to report to law enforcement authorities of any
                      actions that may be considered illegal, as well as any
                      information it receives of such illegal conduct. When
                      requested, we will co-operate fully with law enforcement
                      agencies in any investigation of alleged illegal activity
                      on the internet.
                    </li>
                    <li>
                      Submissions and unauthorised use of any materials
                      contained on the Dock Appointment System may violate
                      copyright laws, trademark laws, the laws of privacy and
                      publicity, certain communications statutes and regulations
                      and other applicable laws and regulations. You alone are
                      responsible for your actions or the actions of any person
                      using your username and/or password. As such, you shall
                      indemnify and hold us and our officers, directors,
                      employees, affiliates, agents, licensors, and business
                      partners harmless from and against any and all loss,
                      costs, damages, liabilities, and expenses (including
                      attorneys&apos; fees) incurred in relation to, arising
                      from, or for the purpose of avoiding, any claim or demand
                      from a third party that your use of the Dock Appointment
                      System or the use of the Dock Appointment System by any
                      person using your user name and/or password (including
                      without limitation your participation in the posting areas
                      or your Submissions) violates any applicable law or
                      regulation, or the rights of any third party.
                    </li>
                    <li>
                      We reserve the right to terminate access to this Dock
                      Appointment System at any time and without notice. Further
                      this limited license terminates automatically, without
                      notice to you, if you br/each any of these Terms of Use.
                      Upon termination, you must immediately destroy any
                      downloaded and printed materials.&nbsp;Any provision of
                      the Terms of Use which imposes an obligation or creates a
                      right that by its nature will be valid after termination
                      or expiration of the Terms of Use shall survive the
                      termination or expiration of the Terms of Use.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>USER WARRANTIES AND RESTRICTIONS</strong>
                  <ol>
                    <li>
                      You represent and warrant that: (a) your use of Dock
                      Appointment System and/or Services will not violate any
                      applicable law or regulation; (b) all information that is
                      submitted to us in connection with &lt;&lt;&gt;&gt; and/or
                      Services is true, accurate and lawful; (c) use of the
                      content and material you supply does not br/each any
                      applicable Agreement and will not cause injury to any
                      person or entity (including that the content or material
                      is not defamatory). If at any time, the information
                      provided by you is found to be false or inaccurate, we
                      will have the right to reject registration, cancel all
                      orders, and restrict you from using the Services and other
                      affiliated services in the future without any prior
                      intimation whatsoever. You agree to indemnify us and our
                      affiliates for all claims br/ought by a third party
                      against it or its affiliates arising out of or in
                      connection with a br/each of any of these warranties.
                    </li>
                    <li>
                      You will use Dock Appointment System for lawful purposes
                      only and will not undertake any activity that is harmful
                      to Dock Appointment System or its content or otherwise not
                      envisaged through the Dock Appointment System. You have a
                      limited license to access and use Dock Appointment System
                      solely for the purpose of availing the Services, subject
                      to these Terms of Use.&nbsp;
                    </li>

                    <li>
                      You will not do any of the following:
                      <ol>
                        <li>
                          Delete or modify any content on Dock Appointment
                          System, such as any information regarding the
                          Services, their performance, sales or pricing;
                        </li>
                        <li>
                          Use any engine, software, tool, agent or other
                          mechanism (such as spiders, robots, avatars, worms,
                          time bombs etc.) to navigate or search Dock
                          Appointment System;
                        </li>
                        <li>
                          Make false or malicious statements against the
                          Services, Dock Appointment System or us;
                        </li>
                        <li>
                          Post, copy, submit, upload, distribute, or otherwise
                          transmit or make available any software or other
                          computer files that contain a virus or other harmful
                          component, or otherwise disrupt or damage Dock
                          Appointment System and/or Services or any connected
                          network, or otherwise interfere with any person or
                          entity&rsquo;s use or enjoyment of Dock Appointment
                          System and/or the Services;
                        </li>
                        <li>
                          Introduce any trojans, viruses, any other malicious
                          software, any bots or scrape Dock Appointment System
                          for any information;&nbsp;
                        </li>
                        <li>
                          Probe, scan, or test the vulnerability of any system,
                          security or authentication measures implemented by us
                          or otherwise tamper or attempt to tamper with our
                          technological design and architecture;
                        </li>
                        <li>
                          Hack into or introduce malicious software of any kind
                          onto Dock Appointment System;
                        </li>
                        <li>
                          Gain unauthorized access to, or interfere with, or
                          damage, or disrupt the server on which the details
                          connected to the Services are stored, or any other
                          server, computer, or database connected to the
                          Services; or
                        </li>
                        <li>
                          Engage in any form of antisocial, disruptive, or
                          destructive acts, including &ldquo;flaming,&rdquo;
                          &ldquo;spamming,&rdquo; &ldquo;flooding,&rdquo;
                          &ldquo;trolling,&rdquo;, &ldquo;phishing&rdquo; and
                          &ldquo;griefing&rdquo; as those terms are commonly
                          understood and used on the internet.
                        </li>
                      </ol>
                    </li>
                    <li>
                      You are prohibited from hosting, displaying, uploading,
                      modifying, publishing, transmitting, updating or sharing
                      on or through Dock Appointment System, any information
                      that:
                      <ol>
                        <li>
                          belongs to another person and to which you do not have
                          any right;
                        </li>
                        <li>
                          is harmful, harassing, blasphemous, defamatory,
                          obscene, pornographic, paedophilic, invasive of
                          another&rsquo;s privacy, hateful, relating to or
                          encouraging money laundering or gambling, or otherwise
                          harmful in any manner whatsoever;
                        </li>
                        <li>harms minors in any way;</li>
                        <li>
                          infringes any patent, trademark, copyright or other
                          proprietary rights;
                        </li>
                        <li>violates any law for the time being in force;</li>
                        <li>
                          deceives or misleads the addressee about the origin of
                          such messages or communicates any information which is
                          grossly offensive or menacing in nature;
                        </li>
                        <li>impersonates or defames another person; or</li>
                        <li>
                          contains software viruses or any other computer code,
                          files or programs designed to interrupt, destroy or
                          limit the functionality of any computer resource.
                        </li>
                      </ol>
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>INDEMNIFICATION AND LIMITATION OF LIABILITY</strong>
                  <p>
                    You agree to indemnify, defend and hold harmless us, our
                    affiliates, officers, directors, employees, consultants,
                    licensors, agents, and representatives from and against any
                    and all third- party claims, losses, liabilities, damages,
                    and/or costs (including reasonable attorney fees and costs)
                    arising from your access to or use of Dock Appointment
                    System or the Services, violation of these Terms of Use, or
                    infringement of any of our or any third-party intellectual
                    property or other rights. We will notify you promptly of any
                    such claim, loss, liability, or demand, and in addition to
                    the foregoing, you agree to provide us with reasonable
                    assistance, at your expense, in defending any such claim,
                    loss, liability, damage, or cost.
                  </p>
                </li>
                <li>
                  <strong>&nbsp;APPLICABLE LAW AND JURISDICTION:</strong>
                  <p>
                    These Terms of Use are governed by and to be interpreted in
                    accordance with laws of India, without regard to the choice
                    or conflicts of law provisions of any jurisdiction. You
                    agree, in the event of any dispute arising in relation to
                    these Terms of Use or any dispute arising in relation to the
                    Dock Appointment System whether in contract or tort or
                    otherwise, to submit to the jurisdiction of the courts
                    located at Mumbai, India for the resolution of all such
                    disputes.
                  </p>
                </li>{" "}
                <li>
                  <strong>GRIEVANCE OFFICER:</strong>
                  <p>
                    In accordance with the applicable law, any grievances which
                    you may have with respect to the information shared by you
                    with us hereunder and its treatment or any grievance related
                    to Services being availed hereunder, may be directed by you
                    to such grievance officer at [●] or at the below mentioned
                    coordinate:
                  </p>
                  <p>
                    <strong>Name</strong>:<strong>&nbsp;</strong>[●]
                  </p>
                  <p>
                    <strong>Designation</strong>: [●]
                  </p>
                  <p>
                    <strong>Email Address</strong>: [●]
                  </p>
                  <p>
                    <strong>Registered Office</strong>: [●]
                  </p>
                </li>
                <li>
                  <strong>FORCE MAJEURE</strong>
                  <p>
                    We will not be held responsible for any delay or failure to
                    comply with its obligations if the delay or failure arises
                    from any cause which is beyond our reasonable control.
                  </p>
                </li>
                <li>
                  <strong>WAIVER</strong>
                  <p>
                    No provision in these Terms of Use will be deemed waived and
                    no br/each excused, unless such waiver or consent is in
                    writing and signed by us. Any consent by us to, or waiver of
                    your br/each, whether expressed or implied, will not
                    constitute consent to, waiver of, or excuse for any other
                    different or subsequent br/each.
                  </p>
                </li>
                <li>
                  <strong>SEVERABILITY</strong>
                  <p>
                    If any provision of these Terms of Use is held by a court of
                    competent jurisdiction to be unenforceable under applicable
                    law, then such provision will be excluded from these Terms
                    of Use and the remainder of these Terms of Use will be
                    interpreted as if such provision were so excluded and will
                    be enforceable in accordance with its terms; provided
                    however that, in such event, these Terms of Use will be
                    interpreted so as to give effect, to the greatest extent
                    consistent with and permitted by applicable law, to the
                    meaning and intention of the excluded provision as
                    determined by such court of competent jurisdiction.
                  </p>
                </li>
                <li>
                  <strong>AMENDMENT&nbsp;</strong>
                  <p>
                    These Terms of Use are subject to amendments and
                    modifications and may be updated from time to time, without
                    any advance notice. You are requested to regularly review
                    the Terms of Use as available on Dock Appointment System.
                    You relationship with the Dock Appointment System will be
                    governed by the most current version of these Terms of Use,
                    as published on Dock Appointment System.
                  </p>
                </li>
                <li>
                  <strong>MISCELLANEOUS</strong>&nbsp;
                  <ol>
                    <li>
                      In addition to these Terms of Use, you will also ensure
                      that you are in compliance with the terms and conditions
                      of the third parties, such as bank offers terms and
                      conditions, br/and promotional offers, whose links, if
                      any, are contained/embedded in the Services. You agree
                      that we will not be liable for any transaction between
                      itself and any such third parties.
                    </li>
                    <li>
                      These Terms of Use supersede all previous oral and written
                      terms and conditions (if any) communicated to you by us,
                      for the use of Dock Appointment System, and the rights and
                      liabilities with respect to any Services to be provided by
                      us shall be limited to the scope of these Terms of Use.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong>NODAL OFFICER</strong>
                  <p>
                    <strong>Name</strong>:<strong>&nbsp;</strong>[●]
                  </p>
                  <p>
                    <strong>Designation</strong>: [●]
                  </p>
                  <p>
                    <strong>Email Address</strong>: [●]
                  </p>
                  <p>
                    <strong>Registered Office</strong>: [●]
                  </p>
                </li>
                <li>
                  <strong>GST INFORMATION</strong>
                </li>
              </>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
